import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconSmallSelfView",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 3.143C1 2.301 1.611 1.5 2.5 1.5h7c.89 0 1.5.8 1.5 1.643v5.715c0 .842-.61 1.643-1.5 1.643h-7c-.889 0-1.5-.8-1.5-1.643V3.143ZM2.5 2.5c-.215 0-.5.224-.5.643v5.715c0 .42.285.642.5.642h7c.216 0 .5-.223.5-.642V3.143c0-.42-.284-.643-.5-.643h-7Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function f(a, u, i, h, p, e) {
  return r(), l("svg", {
    "aria-label": i.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--small-self-view"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Small Self View",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const b = /* @__PURE__ */ s(o, [["render", f]]);
export {
  b as default
};
//# sourceMappingURL=small-self-view.js.map
